import type {
  Store,
  PricePrice,
  PriceStock,
  AlternativePrice,
  ShippingCollection,
  Price,
  OfferPrices,
  PriceAvailability,
  Shipping,
  Product,
  Maybe,
  ProductProperties,
} from 'src/types';
import type { CurrentCampaign } from 'src/areas/product/types';
import type { Rating } from 'src/components/rating/types';
import type { ProductPriceClickStatus } from 'src/areas/product/actions/types';
import type { OptionTypeEnum } from 'src/components/filter-dropdown';

export enum ViewSize {
  SMALL = 0,
  MEDIUM = 1,
  LARGE = 2,
}

export interface IPriceRowContext {
  offer: Offer;
  product: Product & Maybe<{ coreProperties: ProductProperties }>;
  campaign?: CurrentCampaign | null;
  isFeatured?: boolean;
  setShowUnfeaturedPlaceholder?: () => void;
  isOurChoice?: boolean;
  showUnfeaturedHideButton?: boolean;
  sorting?: OptionTypeEnum;
  viewSize: ViewSize;
  isInPriceList?: boolean;
}

export type MembershipProgram = {
  name: string;
  url: string;
  requiresCompensation: boolean;
};

export type Offer = {
  name?: string | null;
  price?: PricePrice | null;
  offerPrices?: OfferPrices | null;
  availability?: PriceAvailability | null;
  priceId?: string | null;
  store?: Store | null;
  featured: boolean;
  storeInfo?: (string | null)[] | null;
  rating?: Rating | undefined;
  stock?: PriceStock | null;
  externalUri?: string | null;
  alternativePrices?: (AlternativePrice | null)[] | null;
  authorizedDealer: boolean;
  isInternationalPrice: boolean;
  shipping?: ShippingCollection | null;
  shopHasUniqueShippings?: boolean | undefined;
  membershipProgram?: MembershipProgram | null;
  unfilteredShippings?: Array<Shipping>;
  ourChoiceScore: number;
};

export interface IPriceRow {
  item: Price;
  index: number;
  className?: string;
  isInPrimaryList?: boolean;
}

export const ProductPageProductClick = 'ProductPage';
type OnEvent = (
  e:
    | React.MouseEvent<HTMLAnchorElement, MouseEvent>
    | React.KeyboardEvent<HTMLAnchorElement>
    | React.TouchEvent<HTMLAnchorElement>
) => void;

export interface ITableLinkProps {
  rel: string;
  href: string | undefined;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown?: OnEvent;
  onTouchStart?: OnEvent;
  onKeyDown?: OnEvent;
  target: string;
  disabled: boolean;
  featured?: boolean;
}

export interface IOfferContainerProps {
  rel: string;
  to: string | undefined;
  'aria-label': string;
  isExternal: boolean;
  onClick: (e: React.MouseEvent) => void;
  onMouseDown?: OnEvent;
  onTouchStart?: OnEvent;
  onKeyDown?: OnEvent;
  target: string;
  disabled: boolean;
  featured: boolean;
}

export enum ReportRowType {
  NONE = 'none',
  DEFAULT = 'default',
  ALTERNATIVE = 'alternative',
}

export type Align = 'left' | 'right';

export interface IRegularPriceRow {
  onClickOutBounce: (id: number, priceId?: string | null) => void;
  onPriceClick: (
    featured: boolean,
    status: ProductPriceClickStatus,
    isAlternative: boolean
  ) => void;
  className?: string;
}
